import React, { useEffect, useState } from 'react';

const Hero: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [displayText, setDisplayText] = useState('');
  const [isTyping, setIsTyping] = useState(true);

  const rotatingWords = [
    "Software",
    "IoT platform",
    "Cloud Platform",
    "Enterprise Systems",
  ];

  useEffect(() => {
    setIsVisible(true);
    let typingTimer: NodeJS.Timeout;
    let currentIndex = 0;

    const typeWord = () => {
      const currentWord = rotatingWords[currentWordIndex];
      if (isTyping && currentIndex <= currentWord.length) {
        setDisplayText(currentWord.substring(0, currentIndex));
        currentIndex++;
        typingTimer = setTimeout(typeWord, 50); // Typing speed
      } else if (!isTyping && currentIndex >= 0) {
        setDisplayText(currentWord.substring(0, currentIndex));
        currentIndex--;
        typingTimer = setTimeout(typeWord, 30); // Deleting speed
      } else {
        if (isTyping) {
          // Word is fully typed, wait before starting to delete
          setTimeout(() => {
            setIsTyping(false);
            currentIndex = currentWord.length;
            typeWord();
          }, 1000);
        } else {
          // Word is fully deleted, move to next word
          setTimeout(() => {
            setCurrentWordIndex((prevIndex) => (prevIndex + 1) % rotatingWords.length);
            setIsTyping(true);
            currentIndex = 0;
            typeWord();
          }, 300);
        }
      }
    };

    typeWord();

    return () => clearTimeout(typingTimer);
  }, [currentWordIndex, isTyping]);

  return (
    <section id="hero">
      <div className={`hero-content ${isVisible ? 'visible' : ''}`}>
        <div className="dynamic-headline">
          <h1 className="headline-middle typing-text">
            {displayText}<span className="cursor"></span>
          </h1>
          <h1 className="headline-static">
            Solutions<br />Through AI
          </h1>
        </div>
        <a href="#services" className="btn">Explore Our Solutions</a>
      </div>
    </section>
  );
};

export default Hero; 